import {
  DestroyRef,
  Directive,
  ElementRef,
  HostListener,
  inject
} from '@angular/core';

import { ZendeskService } from '@zendesk/services/zendesk.service';

@Directive({
  selector: '[appZendeskSupportToggle]',
  standalone: true
})
export class ZendeskSupportToggleDirective {
  readonly #zendeskService = inject(ZendeskService);
  readonly #host = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    this.#zendeskService.registerToggleElement(this.#host.nativeElement);

    inject(DestroyRef).onDestroy(() => {
      this.#zendeskService.registerToggleElement(null);
    });
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
    this.#zendeskService.toggle();
  }
}
